<template>
  <div class="scan-container">
    <!-- 顶部横幅区域 -->
    <div class="header-banner">
      <img src="/static/images/ctruck/banner.png" alt="背景" class="banner-bg" />
      <div class="logo-overlay">
        <img src="/static/images/ctruck/logo.png" alt="Logo" class="header-logo" />
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="form-wrapper">
        <h1 class="main-title">联合重卡防伪验证系统</h1>
        
        <!-- 扫一扫按钮 -->
        <button class="scan-button-large" @click="scanCode">
          扫一扫
        </button>
        
        <!-- 输入框 -->
        <input 
          v-model="antiCode" 
          class="code-input-field" 
          placeholder="请输入16位数码" 
          @input="handleInput"
          maxlength="19"
        />
        
        <!-- 输入查询按钮 -->
        <button 
          class="query-button-large" 
          @click="queryAnti" 
        >
          输入查询
        </button>
        
        <!-- 提示图片 -->
        <img src="/static/images/ctruck/tip.png" alt="提示" class="tip-image" />
      </div>
    </div>

  </div>
</template>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'CTruckScan',
  data() {
    return {
      antiCode: '',
      eno: '138476474577'
    }
  },
  methods: {
    handleInput() {
      // 每4位数字后自动添加空格，方便用户阅读
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ')
    },
    scanCode() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          let scanResult = res.resultStr
          let scanQRCode = scanResult
          
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/')
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          } else {
            scanQRCode = scanQRCode.substring(0, 16)
          }
          
          this.antiCode = scanQRCode.replace(/(\w{4})(?=\w)/g, '$1 ')

          // 跳转到query页面进行查询
          this.$router.push({
            path: '/ctruck.query',
            query: {
              c: scanQRCode,
              eno: this.eno
            }
          })
        },
        fail: err => {
          console.error('扫码失败:', err)
          alert('扫码失败，请重试')
        }
      })
    },
    queryAnti() {
      const code = this.antiCode.replace(/\s+/g, '')
      
      if (!code) {
        alert('请输入16位防伪数码')
        return
      }
      
      if (code.length !== 16) {
        alert('请输入正确的16位防伪码')
        return
      }
      
      // 跳转到query页面进行查询
        this.$router.push({
          path: '/ctruck.query',
          query: {
            c: code,
            eno: this.eno
          }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxbc22565b3e7a59fd").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'scanQRCode',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
      }).catch(err => {
        console.error('获取微信授权失败:', err)
      })
    }
  },
  mounted() {
    const handleFontSize = () => {
      if (typeof WeixinJSBridge !== 'undefined') {
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
        WeixinJSBridge.on('menu:setfont', function () {
          WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
        })
      }
    }
    
    try {
      if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize)
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
        }
      }
    } catch (error) {
      console.error(error)
    }
  },
  created() {
    this.getWxJs()
    const params = this.$route.query
    if (params.eno) {
      this.eno = params.eno
    }
  }
}
</script>

<style scoped>
.scan-container {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* 顶部横幅区域 */
.header-banner {
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
}

.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-overlay {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
}

.header-logo {
  height: 35px;
  width: auto;
  max-width: 150px;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  padding: 30px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.form-wrapper {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-title {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  text-align: center;
  margin: 0;
  padding: 0;
}

/* 扫一扫按钮 */
.scan-button-large {
  width: 100%;
  height: 55px;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;
}

.scan-button-large:active {
  background: #333333;
}

/* 输入框 */
.code-input-field {
  width: 100%;
  height: 50px;
  padding: 0 16px;
  background: #f5f5f5;
  border: 1px solid #000000;
  border-radius: 8px;
  font-size: 16px;
  color: #333333;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s;
}

.code-input-field:focus {
  border-color: #4a90e2;
}

.code-input-field::placeholder {
  color: #999999;
}

/* 输入查询按钮 */
.query-button-large {
  width: 100%;
  height: 55px;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s, opacity 0.3s;
  text-align: center;
}

.query-button-large:active {
  background: #333333;
}

/* 提示图片 */
.tip-image {
  width: 90vw;
  height: auto;
  margin: 0 auto;
  display: block;
}


/* 响应式调整 */
@media (max-width: 375px) {
  .header-banner {
    height: 180px;
  }
  
  .main-content {
    padding: 25px 15px;
  }
  
  .main-title {
    font-size: 20px;
  }
  
  .scan-button-large,
  .query-button-large {
    height: 50px;
    font-size: 16px;
  }
  
  .code-input-field {
    height: 45px;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CTruck/Scan.vue